// Auto-detect environment
const isLocalhost = window.location.hostname === "localhost";

// Base API URL
export const API_BASE_URL = isLocalhost
  ? "http://localhost:3001"       // local = HTTP
  : "https://siteapi.flytutor.in"; // live = HTTPS
